import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import DetailPageHeader from '../components/detail-page-header';
import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import { logout } from '../reducers/user/reducer';

function LogoutContainer(): React.ReactElement {
  const dispatch = useAppDispatch();
  const userIsLoggedIn = useSelector((s: RootState) => s.User.isLoggedIn);

  useEffect(() => {
    if (userIsLoggedIn) {
      dispatch(logout());
    }
  }, [dispatch, userIsLoggedIn]);

  return <DetailPageHeader title="Logged out" />;
}

export default LogoutContainer;
